<div class="container-fluid psp-container">
  <page-header-breadcrumb
    [pageTitleValue]="pageTitle"
    [pageLinkValue]="'/coupons'"
    [currentPageValue]="'Coupon Details'"
  ></page-header-breadcrumb>
  <div class="card mb-4">
    <div class="coupon-details-container">
      <div class="card-body">
        <div
          class="border-bottom title pb-2 mb-4"
        >
          <h2 class="m-0">Coupon Details</h2>
        </div>
        <h2>Basic Details</h2>
        <div class="card-coupon p-3">
          <div class="p-3 border-bottom">
            <h3>Name</h3>
            <div class="row justify-content-evenly">
              <div class="col-12">
                <label for="couponName">Coupon Name</label>
                <span id="couponName">{{ couponTotalDetails?.couponName }}</span>
              </div>
            </div>
          </div>
          <div class="p-3 border-bottom">
            <h3>Calls</h3>
            <div class="row justify-content-evenly">
              <div class="col-sm-6 col-md-3">
                <label for="finished-calls">Finished Calls</label>
                <span id="finished-calls">{{ couponTotalDetails?.finishedCalls }}</span>
              </div>
              <div class="col-sm-6 col-md-3">
                <label for="cancelled-calls">Cancelled Calls</label>
                <span id="cancelled-calls">{{ couponTotalDetails?.cancelledCalls }}</span>
              </div>
              <div class="col-sm-6 col-md-3">
                <label for="not-completed-calls">Not Completed Calls</label>
                <span id="not-completed-calls">{{
                  couponTotalDetails?.notCompletedCalls
                }}</span>
              </div>
              <div class="col-sm-6 col-md-3">
                <label for="total-calls">Total Calls</label>
                <span id="total-calls">{{ couponTotalDetails?.totalCalls }}</span>
              </div>
            </div>
          </div>
          <div class="p-3">
            <h3>Patients / Doctors</h3>
            <div class="row justify-content-evenly">
              <div class="col-sm-6 col-md-3">
                <label for="patients-number">Number of Unique Patients</label>
                <span id="patients-number">{{ couponTotalDetails?.numberOfUniquePatients }}</span>
              </div>
              <div class="col-sm-6 col-md-3">
                <label for="doctors-number">Number of Unique Doctors</label>
                <span id="doctors-number">{{ couponTotalDetails?.numberOfUniqueDoctors }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <h2>Day By Day Details</h2>
        <div class="card-coupon p-3">
          <div *ngIf="couponDayByDayList?.length" class="table-responsive">
            <table class="table align-items-center table-flush">
              <thead class="thead-light">
                <tr>
                  <th *ngFor="let th of theadArray">
                    {{ th | uppercase }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="pointer"
                  *ngFor="let item of couponDayByDayList"
                >
                  <td>
                    <span>{{ item?.couponName }}</span>
                  </td>
                  <td>
                    <span>{{ item?.couponDay ? item?.couponDay : '' }}</span>
                  </td>
                  <td>
                    <span>{{ item?.finishedCalls }}</span>
                  </td>
                  <td>
                    <span>{{ item?.cancelledCalls }}</span>
                  </td>
                  <td>
                    <span>{{ item?.notCompletedCalls }}</span>
                  </td>
                  <td>
                    <span>{{ item?.totalCalls }}</span>
                  </td>
                  <td>
                    <span>{{ item?.numberOfUniquePatients }}</span>
                  </td>
                  <td>
                    <span>{{ item?.numberOfUniqueDoctors }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
